/**
 * Kshetra Veda - Universal Sticky + Parallax Scroll Hero Curtain Effect
 * Applies strictly to non-homepage and non-product pages.
 */
(() => {
  if (window.KshetraStickyHeroInitialized) return;
  window.KshetraStickyHeroInitialized = true;

  function isExcludedPage() {
    return (
      window.location.pathname === '/' ||
      window.location.pathname === '/index' ||
      window.location.pathname === '' ||
      window.location.pathname.includes('/products/') ||
      window.location.pathname.includes('/cart') ||
      window.location.pathname.includes('/account') ||
      window.location.pathname.includes('/challenge') ||
      document.body.classList.contains('template-index') ||
      document.body.classList.contains('template-product') ||
      document.body.classList.contains('template-cart') ||
      !!document.querySelector('.template-index, .template-product, .template-cart, [data-template="index"], [data-template="product"], [data-template="cart"], .kshetra-pdp, .cart-page')
    );
  }

  function initStickyHeroParallax() {
    // Disable completely on homepage and product detail pages
    if (isExcludedPage()) return;

    const mainContent = document.querySelector('#MainContent');
    if (!mainContent) return;

    let heroEl = null;
    let curtainEl = null;

    // 1. Look for explicit inner Hero elements (e.g. .kv-story-hero, .kv-recipes-hero, .journal-hero, .kv-lab-hero, .kv-shop-hero)
    const heroCandidate = mainContent.querySelector(
      '.kv-story-hero, .kv-recipes-hero, .journal-hero, .kv-lab-hero, .kv-shop-hero, .page-hero, .blog-hero, .kshetra-hero'
    );

    if (heroCandidate && heroCandidate.offsetHeight > 100) {
      heroEl = heroCandidate;

      // Special handling for Shop Collection page so category filter bar stays visible
      if (heroCandidate.classList.contains('kv-shop-hero')) {
        const filterBar = mainContent.querySelector('.kv-shop-filter');
        const gridBand = mainContent.querySelector('.kv-shop-grid-band');
        if (filterBar) {
          filterBar.classList.add('kv-shop-filter-always-visible');
        }
        curtainEl = gridBand || heroCandidate.nextElementSibling;
      } else if (heroCandidate.nextElementSibling) {
        curtainEl = heroCandidate.nextElementSibling;
      } else {
        const parentSec = heroCandidate.closest('.shopify-section');
        if (parentSec && parentSec.nextElementSibling) {
          curtainEl = parentSec.nextElementSibling;
        }
      }
    }

    // 2. Fallback: Use 1st shopify-section as Hero and 2nd as Curtain on non-excluded pages
    if (!heroEl || !curtainEl) {
      const firstSec = mainContent.querySelector('.shopify-section');
      if (firstSec && firstSec.nextElementSibling) {
        heroEl = firstSec;
        curtainEl = firstSec.nextElementSibling;
      }
    }

    if (!heroEl || !curtainEl) return;

    // Apply Sticky & Curtain Classes
    heroEl.classList.add('kv-sticky-hero-active');
    curtainEl.classList.add('kv-curtain-content-active');

    // Ensure parent container doesn't clip sticky position
    mainContent.style.overflow = 'visible';
    const parentContainer = heroEl.parentElement;
    if (parentContainer) parentContainer.style.overflow = 'visible';

    // GSAP ScrollTrigger Parallax & Scaling Depth
    if (window.gsap && window.ScrollTrigger) {
      const heroText = heroEl.querySelector(
        '.kv-story-hero-copy, .kv-recipes-hero-content, .journal-hero__content, .kv-lab-container, .kv-story-hero-content, .kv-shop-hero-copy, .kv-shop-container, .hero__content, h1'
      ) || heroEl;
      const heroBg = heroEl.querySelector(
        '.kv-story-hero-media, .kv-recipes-hero-media, .journal-hero__image, .kv-lab-hero, .kv-shop-hero, img, video, .hero__media'
      ) || heroEl;

      window.gsap.to(heroText, {
        yPercent: 25,
        opacity: 0.15,
        scale: 0.94,
        ease: 'none',
        scrollTrigger: {
          trigger: heroEl,
          start: 'top top',
          end: 'bottom top',
          scrub: true
        }
      });

      if (heroBg && heroBg !== heroText) {
        window.gsap.to(heroBg, {
          yPercent: 15,
          scale: 1.05,
          ease: 'none',
          scrollTrigger: {
            trigger: heroEl,
            start: 'top top',
            end: 'bottom top',
            scrub: true
          }
        });
      }
    }
  }

  // Inject Sticky, Curtain Overlay & Page Safeguards
  const style = document.createElement('style');
  style.textContent = `
    .kv-sticky-hero-active {
      position: sticky !important;
      top: var(--header-height, 88px) !important;
      z-index: 1 !important;
      will-change: transform, opacity;
      transition: opacity 0.2s ease;
    }

    .kv-story-page > *:not(.kv-story-hero),
    .journal-page > *:not(.journal-hero),
    .kv-recipes-page > *:not(.kv-recipes-hero),
    .kv-lab-reports-wrapper > *:not(.kv-lab-hero),
    .kv-lab-body,
    .kv-shop-page > *:not(.kv-shop-hero):not(.kv-shop-filter),
    .kv-shop-grid-band,
    .kv-shop-cta,
    .kv-sticky-hero-active ~ .shopify-section,
    .kv-curtain-content-active:not(.kv-shop-filter),
    .shopify-section.kv-curtain-content-active {
      position: relative !important;
      z-index: 10 !important;
      background: #faf9f6 !important;
      width: 100% !important;
      max-width: 100% !important;
    }

    .kv-shop-filter-always-visible,
    .kv-shop-filter {
      position: sticky !important;
      top: 0 !important;
      z-index: 100 !important;
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      background: #faf9f6 !important;
      border-radius: 0 !important;
      box-shadow: 0 4px 20px rgba(3, 54, 30, 0.08) !important;
    }

    /* Elevate Footer so sticky hero is 100% covered when scrolling to bottom */
    footer,
    .footer,
    #shopify-section-footer-group,
    .shopify-section-group-footer-group {
      position: relative !important;
      z-index: 50 !important;
      background: #03361e !important;
    }

    /* Homepage, PDP & Cart Safeguards */
    .template-index .kv-sticky-hero-active,
    .template-product .kv-sticky-hero-active,
    .template-cart .kv-sticky-hero-active,
    body[class*="index"] .kv-sticky-hero-active,
    body[class*="product"] .kv-sticky-hero-active,
    body[class*="cart"] .kv-sticky-hero-active,
    body:has(.cart-page) .kv-sticky-hero-active {
      position: relative !important;
      top: auto !important;
      z-index: 1 !important;
      margin-top: 0 !important;
    }

    @media screen and (max-width: 749px) {
      .kv-curtain-content-active {
        border-top-left-radius: 20px !important;
        border-top-right-radius: 20px !important;
        box-shadow: 0 -14px 36px rgba(0, 0, 0, 0.14) !important;
      }

      .template-collection .kv-curtain-content-active,
      body[class*="template-collection"] .kv-curtain-content-active,
      .template-cart .kv-curtain-content-active,
      body[class*="template-cart"] .kv-curtain-content-active,
      body[class*="cart"] .kv-curtain-content-active,
      body:has(.cart-page) .kv-curtain-content-active {
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
      }
    }
  `;
  document.head.appendChild(style);

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initStickyHeroParallax, 200);
  });

  if (document.readyState !== 'loading') {
    setTimeout(initStickyHeroParallax, 200);
  }
})();
